(function () {
  'use strict';

  /* ── state ─────────────────────────────────────── */
  var images = [];
  var currentIndex = 0;
  var scale = 1;
  var panX = 0;
  var panY = 0;
  var isDragging = false;
  var dragStartX = 0;
  var dragStartY = 0;
  var touchStartX = 0;
  var built = false;

  /* ── DOM refs ───────────────────────────────────── */
  var overlay, mainImg, stage, counterEl, thumbsEl, prevBtn, nextBtn;

  /* ── Shopify CDN URL helpers ─────────────────────── */
  function shopifyImgUrl(src, width) {
    try {
      var u = new URL(src);
      u.searchParams.set('width', width);
      u.searchParams.delete('height');
      return u.toString();
    } catch (e) { return src; }
  }

  function bestSrc(img) {
    var srcset = img.getAttribute('srcset') || '';
    if (srcset) {
      var maxW = 0, maxUrl = '';
      srcset.split(',').forEach(function (entry) {
        var parts = entry.trim().split(/\s+/);
        if (parts.length < 2) return;
        var w = parseInt(parts[parts.length - 1], 10);
        if (!isNaN(w) && w > maxW) { maxW = w; maxUrl = parts[0]; }
      });
      if (maxUrl) return maxUrl;
    }
    return shopifyImgUrl(img.src, 2048);
  }

  function thumbSrc(img) { return shopifyImgUrl(img.src, 180); }

  /* ── Collect images ──────────────────────────────── */
  function collectImages() {
    var result = [];
    document.querySelectorAll('.product__media-list .product__media-item').forEach(function (item) {
      var container = item.querySelector('.media-type-image');
      if (!container) return;
      var img = container.querySelector('img');
      if (!img) return;
      result.push({ full: bestSrc(img), thumb: thumbSrc(img), alt: img.alt || '' });
    });
    return result;
  }

  function itemToImageIndex(clickedItem) {
    var count = 0, found = -1;
    document.querySelectorAll('.product__media-list .product__media-item').forEach(function (item) {
      if (!item.querySelector('.media-type-image')) return;
      if (item === clickedItem) found = count;
      count++;
    });
    return found;
  }

  /* ── DOM helpers ─────────────────────────────────── */
  function el(tag, cls, attrs) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (attrs) Object.keys(attrs).forEach(function (k) { e.setAttribute(k, attrs[k]); });
    return e;
  }

  function mkBtn(cls, dataGl, label, text) {
    var b = el('button', cls, { 'data-gl': dataGl, 'aria-label': label, 'type': 'button' });
    b.textContent = text;
    return b;
  }

  function mkNavBtn(cls, dataGl, label) {
    var b = el('button', cls, { 'data-gl': dataGl, 'aria-label': label, 'type': 'button' });
    var icon = el('span', 'luxx-gl__nav-icon');
    b.appendChild(icon);
    return b;
  }

  /* ── Build overlay eagerly ────────────────────────── */
  function build() {
    if (built) return;
    built = true;

    images = collectImages();
    if (!images.length) return;

    /* overlay wrapper */
    overlay = el('div', 'luxx-gl', {
      'role': 'dialog', 'aria-modal': 'true',
      'aria-label': 'Product image gallery', 'tabindex': '-1'
    });

    /* toolbar: counter | reset  close */
    var toolbar = el('div', 'luxx-gl__toolbar');
    counterEl = el('span', 'luxx-gl__counter');
    var actions = el('div', 'luxx-gl__actions');
    actions.appendChild(mkBtn('luxx-gl__btn', 'zoom-reset', 'Reset zoom', '◎'));
    actions.appendChild(mkBtn('luxx-gl__btn luxx-gl__btn--close', 'close', 'Close', '✕'));
    toolbar.appendChild(counterEl);
    toolbar.appendChild(actions);
    overlay.appendChild(toolbar);

    /* body — position:relative so arrows + zoom controls overlay it */
    var body = el('div', 'luxx-gl__body');

    stage = el('div', 'luxx-gl__stage');
    mainImg = el('img', 'luxx-gl__img');
    mainImg.setAttribute('draggable', 'false');
    mainImg.setAttribute('alt', '');
    stage.appendChild(mainImg);
    body.appendChild(stage);

    /* arrows — full-height side panels, absolutely positioned inside body */
    prevBtn = mkNavBtn('luxx-gl__nav luxx-gl__nav--prev', 'prev', 'Previous image');
    nextBtn = mkNavBtn('luxx-gl__nav luxx-gl__nav--next', 'next', 'Next image');
    body.appendChild(prevBtn);
    body.appendChild(nextBtn);

    /* floating zoom controls — bottom-right of body */
    var zoomControls = el('div', 'luxx-gl__zoom-controls');
    zoomControls.appendChild(mkBtn('luxx-gl__zoom-btn', 'zoom-out', 'Zoom out', '−'));
    zoomControls.appendChild(mkBtn('luxx-gl__zoom-btn', 'zoom-in',  'Zoom in',  '+'));
    body.appendChild(zoomControls);

    overlay.appendChild(body);

    /* thumbnails */
    var thumbsWrap = el('div', 'luxx-gl__thumbs-wrap');
    thumbsEl = el('div', 'luxx-gl__thumbs');

    images.forEach(function (data, i) {
      var b = el('button', 'luxx-gl__thumb', {
        'type': 'button',
        'aria-label': 'View image ' + (i + 1),
        'data-index': String(i)          /* reliable index for event delegation */
      });
      var t = el('img');
      t.setAttribute('alt', '');
      t.setAttribute('loading', 'lazy');
      t.src = data.thumb;
      b.appendChild(t);
      thumbsEl.appendChild(b);
    });

    /* single delegated listener — avoids per-button closure bugs */
    thumbsEl.addEventListener('click', function (e) {
      var b = e.target.closest('.luxx-gl__thumb');
      if (!b) return;
      var i = parseInt(b.getAttribute('data-index'), 10);
      if (isNaN(i)) return;
      resetZoom();
      goTo(i);
    });

    thumbsWrap.appendChild(thumbsEl);
    overlay.appendChild(thumbsWrap);
    document.body.appendChild(overlay);

    if (images.length < 2) {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
      thumbsWrap.style.display = 'none';
    }

    /* ── events ── */
    overlay.addEventListener('click', function (e) {
      var action = e.target.closest('[data-gl]');
      if (!action) return;
      switch (action.getAttribute('data-gl')) {
        case 'close':      close(); break;
        case 'prev':       navigate(-1); break;
        case 'next':       navigate(1); break;
        case 'zoom-in':    zoom(0.3); break;
        case 'zoom-out':   zoom(-0.3); break;
        case 'zoom-reset': resetZoom(); break;
      }
    });

    stage.addEventListener('click', function (e) { if (e.target === stage) close(); });

    stage.addEventListener('wheel', function (e) {
      e.preventDefault();
      zoom(e.deltaY < 0 ? 0.2 : -0.2);
    }, { passive: false });

    stage.addEventListener('mousedown', function (e) {
      if (scale <= 1 || e.button !== 0) return;
      isDragging = true;
      dragStartX = e.clientX - panX;
      dragStartY = e.clientY - panY;
      stage.classList.add('luxx-gl__stage--grabbing');
      e.preventDefault();
    });

    document.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      panX = e.clientX - dragStartX;
      panY = e.clientY - dragStartY;
      mainImg.classList.add('luxx-gl__img--notransition');
      applyTransform();
    });

    document.addEventListener('mouseup', function () {
      if (!isDragging) return;
      isDragging = false;
      mainImg.classList.remove('luxx-gl__img--notransition');
      stage.classList.remove('luxx-gl__stage--grabbing');
      if (scale > 1) stage.classList.add('luxx-gl__stage--grab');
    });

    stage.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    stage.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 55) navigate(dx < 0 ? 1 : -1);
    }, { passive: true });

    document.addEventListener('keydown', onKeyDown);
  }

  /* ── Transform ───────────────────────────────────── */
  function applyTransform() {
    mainImg.style.transform = 'translate(' + panX + 'px,' + panY + 'px) scale(' + scale + ')';
  }

  function zoom(delta) {
    scale = Math.min(5, Math.max(0.5, scale + delta));
    applyTransform();
    stage.classList.toggle('luxx-gl__stage--grab', scale > 1);
  }

  function resetZoom() {
    scale = 1; panX = 0; panY = 0;
    applyTransform();
    stage.classList.remove('luxx-gl__stage--grab', 'luxx-gl__stage--grabbing');
  }

  /* ── Navigation ─────────────────────────────────── */
  function navigate(delta) {
    if (images.length < 2) return;
    resetZoom();
    goTo((currentIndex + delta + images.length) % images.length);
  }

  function goTo(index) {
    currentIndex = index;
    var data = images[index];

    mainImg.setAttribute('src', data.full);
    mainImg.setAttribute('alt', data.alt);
    counterEl.textContent = (index + 1) + ' / ' + images.length;

    /* thumbnail highlight via data-index (avoids children[] ordering assumptions) */
    thumbsEl.querySelectorAll('.luxx-gl__thumb').forEach(function (t) {
      t.classList.toggle('luxx-gl__thumb--active', t.getAttribute('data-index') === String(index));
    });
    var activeThumb = thumbsEl.querySelector('[data-index="' + index + '"]');
    if (activeThumb) activeThumb.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });

    prefetch((index + 1) % images.length);
    prefetch((index - 1 + images.length) % images.length);
  }

  function prefetch(i) {
    if (i === currentIndex) return;
    var p = new Image();
    p.src = images[i].full;
  }

  /* ── Open / Close ─────────────────────────────────── */
  function open(index) {
    if (!built || !images.length) return;
    currentIndex = Math.max(0, Math.min(index, images.length - 1));
    resetZoom();
    goTo(currentIndex);
    overlay.classList.add('luxx-gl--open');
    document.body.style.overflow = 'hidden';
    overlay.focus();
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('luxx-gl--open');
    document.body.style.overflow = '';
    resetZoom();
  }

  function onKeyDown(e) {
    if (!overlay || !overlay.classList.contains('luxx-gl--open')) return;
    if (e.key === 'Escape')             { close(); return; }
    if (e.key === 'ArrowLeft')          { e.preventDefault(); navigate(-1); }
    if (e.key === 'ArrowRight')         { e.preventDefault(); navigate(1); }
    if (e.key === '+' || e.key === '=') zoom(0.3);
    if (e.key === '-')                  zoom(-0.3);
    if (e.key === '0')                  resetZoom();
  }

  /* ── Gallery page swipe: pass swipes through nav buttons to slider ─ */
  function initGallerySwipe() {
    var viewer = document.querySelector('[id^="GalleryViewer-"]');
    if (!viewer) return;
    var slider = viewer.querySelector('[id^="Slider-Gallery-"]');
    if (!slider) return;
    var navBtns = viewer.querySelectorAll('.pgallery-nav');
    if (!navBtns.length) return;

    navBtns.forEach(function (btn) {
      var startX = 0, startY = 0, swiped = false;

      btn.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        swiped = false;
      }, { passive: true });

      btn.addEventListener('touchmove', function (e) {
        if (Math.abs(e.touches[0].clientX - startX) > 8) swiped = true;
      }, { passive: true });

      btn.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (swiped && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
          /* horizontal swipe — scroll slider manually, suppress tap */
          e.preventDefault();
          var item = slider.querySelector('.product__media-item');
          var itemW = item ? item.offsetWidth : slider.clientWidth;
          slider.scrollBy({ left: dx < 0 ? itemW : -itemW, behavior: 'smooth' });
        }
        /* if not swiped, the tap fires normally → Dawn button handler navigates */
      }, { passive: false });
    });
  }

  /* ── Init ─────────────────────────────────────────── */
  function init() {
    var list = document.querySelector('.product__media-list');
    if (!list) return;
    build();
    initGallerySwipe();
    list.addEventListener('click', function (e) {
      var opener = e.target.closest('.product__modal-opener--image');
      if (!opener) return;
      var item = opener.closest('.product__media-item');
      if (!item) return;
      var idx = itemToImageIndex(item);
      if (idx < 0) return;
      open(idx);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
